import './index.sass';
import Sortable from 'sortablejs'

export default () => {
  new Sortable(jsSorting, {
    animation: 150
  });
}